<template>
  <div v-if="value" class="form-fieldhelp">
    <label>?</label>
    <div class="form-fieldhelp-text">
      <div v-html="value" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Hint',

  props: {
    value: {
      type: String,
      default: undefined
    }
  }
}
</script>
